import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
// import downloadCsv from "download-csv";
// import XLSX from "xlsx";

export default class XLSDownloader extends React.Component {
    downloadXLSX = async () => {
        return import(/* webpackChunkName: "xlsx" */ "xlsx")
            .then(_ => _.default)
            .then(async XLSX => {
                let ws = await XLSX.utils.json_to_sheet(this.props.data.map(_ => _.toJS()).toArray(), {header: Object.keys(this.props.data.first)});
                let wb = await XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
                const wbout = XLSX.writeFile(wb, `${new Date().toISOString()}_sales.xlsx`);
                return wbout;
            });
    };
    render() {
        return (
            <Button type="default" style={{height: this.props.height || "auto"}} onClick={this.downloadXLSX}>
                {" "}
                Download{" "}
            </Button>
        );
    }
    static propTypes = {
        data: PropTypes.object,
        cols: PropTypes.object,
        height: PropTypes.string
    };
}
